import React from "react";
import { Navigate } from "react-router-dom";

const SystemPanelGeneral = React.lazy(
  () => import("../../../../../components/system-panel/components/panel/page"),
);

export const systemRoute = [
  {
    path: "general",
    element: <SystemPanelGeneral />,
  },

  {
    path: "",
    element: <Navigate replace to="/options/system/general" />,
  },
];
